module.exports = __webpack_public_path__ + "static/media/icon-success.5d7e9680.svg";